import React from "react";
// eslint-disable-next-line import/no-cycle
import { SvgProps } from ".";

export const Globe: React.FC<SvgProps> = ({ fill, opacity }) => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-labelledby="Globe"
    >
      <title id="Globe">Globe</title>
      <g
        id="Globe"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity={opacity || "1"}
      >
        <g id="Group">
          <rect id="Rectangle" x="0" y="0" width="40" height="40" />
          <circle
            id="Oval-Copy-3"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            cx="20"
            cy="19.9979557"
            r="15"
          />
          <path
            d="M19.5454545,34.9979557 C24.0641479,34.9979557 27.7272727,28.2822269 27.7272727,19.9979557 C27.7272727,11.7136844 24.0641479,4.99795567 19.5454545,4.99795567"
            id="Oval-Copy-4"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.2727273,34.9979557 C16.7914207,34.9979557 20.4545454,28.2822269 20.4545454,19.9979557 C20.4545454,11.7136844 16.7914207,4.99795567 12.2727273,4.99795567"
            id="Oval-Copy-5"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(16.363636, 19.997956) rotate(-180.000000) translate(-16.363636, -19.997956) "
          />
          <line
            x1="20"
            y1="4.99795567"
            x2="20"
            y2="34.9979557"
            id="Line-3"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="35"
            y1="19.9979557"
            x2="4.99999999"
            y2="19.9979557"
            id="Line-3"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default {};
